<template>
    <div class="kb-home">
        <div class="panel h1-panel">
            <div class="panel-heading">
                <h1><router-link to="/kb">Knowledge Base</router-link></h1>
            </div>
        </div>

        <section class="panel search-panel">
            <div class="panel-body">
                <h2>How can we help?</h2>
                <form @submit.prevent="goToSearchQueryUrl()">
                    <div class="form-group">
                        <input
                            class="form-control"
                            type="text"
                            placeholder="Search for a topic (lighting, texturing, ...)"
                            v-model="searchQuery">
                        <router-link :to="getSearchQueryLocation()">
                            <i class="fa fa-search"></i>
                        </router-link>
                    </div>
                </form>
            </div>
        </section>

        <section class="panel category-panel">
            <div class="panel-body">
                <h2>Browse by Category</h2>
                <ol v-if="!isLoadingCategories">
                    <li v-for="category in categories">
                        <router-link :to="getCategoryLocation(category)">
                            <img
                                class="category-image"
                                :src="category.imageUrl"
                                v-if="category.imageUrl">
                            <img
                                class="category-image"
                                src="../assets/img/ttto-thumbnail.jpg"
                                v-else>
                            <div class="category-label-wrapper">
                                <div class="category-label">{{ category.label }}</div>
                                <div class="category-article-count">{{ toArticleText(category.articleCount) }}</div>
                            </div>
                        </router-link>
                    </li>
                </ol>
                <div class="loading-msg" v-else>
                    Loading...
                </div>
            </div>
        </section>

        <!--<section class="panel term-panel">
            <div class="panel-body">
                <h2>Browse by Term</h2>
                <ol>
                    <li v-for="term in terms">
                        <a href="#">
                            <span class="term-name">{{ term.name }}</span>
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </li>
                </ol>
            </div>
        </section>-->

        <section
            class="panel new-article-panel"
            v-if="canAuthor">
            <div class="panel-body">
                <kb-block-link
                    title="Create an article"
                    :to="getArticleEditorLocation()">
                </kb-block-link>
            </div>
        </section>

        <kb-feedback></kb-feedback>
    </div>
</template>

<script>
    import KbBlockLink from './widgets/KbBlockLink';
    import KbFeedback from './widgets/KbFeedback';

    export default {
        components: {
            KbBlockLink,
            KbFeedback,
        },

        data() {
            return {
                searchQuery: '',
                //terms: [],

                isLoadingCategories: true,
            };
        },

        async mounted() {
            this.isLoadingCategories = true;
            await this.$store.dispatch('ensureKbCategories');
            this.isLoadingCategories = false;

            /*this.terms = [
                { name: 'Intermediate 2018' },
                { name: 'Foundation 2018' },
                { name: 'Foundation 2017' },
            ];*/
        },

        methods: {
            toArticleText(count) {
                if (count === 1) {
                    return '1 article';
                } else {
                    return `${count} articles`;
                }
            },

            getSearchQueryLocation() {
                return {
                    path: '/kb-search',
                    query: {
                        q: this.searchQuery
                    }
                };
            },

            getCategoryLocation(category) {
                return {
                    path: `/kb/${category.name}`
                };
            },

            getArticleEditorLocation() {
                return {
                    path: '/kb-article-editor'
                };
            },

            goToSearchQueryUrl() {
                this.$router.push(this.getSearchQueryLocation());
            }
        },

        computed: {
            categories() {
                const cats = this.$store.getters.kbCategories.slice();
                return cats.sort((a, b) => a.label.localeCompare(b.label));
            },

            canAuthor() {
                const userRoles = JSON.parse(localStorage.roles);
                const allowedRoles = [
                    'OnlineDirector',
                    'Supervisor',
                    'Faculty',
                ];
                return userRoles.some(r => allowedRoles.includes(r));
            },
        },
    }
</script>

<style lang="scss" scoped>
    .clear-button {
        border: none;
        background: none;
    }

    .h1-panel {
        display: inline-block;

        .panel-heading {
            height: auto;
            width: auto;
        }

        h1 {
            margin: 10px 0;
            display: inline-block;

            a {
                color: inherit;
                text-decoration: none;
                &:hover {
                    color: #33ccff;
                }
            }
        }
    }

    .search-panel {
        .panel-body {
            padding: 40px 20px 50px;
        }

        h2 {
            text-align: center;
            margin: 0 0 20px 0;
        }

        .form-group {
            width: 80%;
            max-width: 600px;
            display: block;
            margin: 0 auto;
            position: relative;
            font-size: 16px;
            input {
                padding-right: calc(0.5rem + 45px) !important;
                font-size: inherit;
            }
            a {
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                width: 45px;
                height: 45px;
                top: 0;
                right: 0;
                color: #b0b0b0;
                text-decoration: none;
                &:hover {
                    background-color: #363636;
                }
            }
        }
    }

    .category-panel {
        .panel-body {
            padding: 40px 20px;
        }

        h2 {
            margin: 0 0 40px 0;
        }

        ol {
            list-style-type: none;
            margin: 0 0 -20px 0;
            padding: 0;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }

        li {
            width: calc(50% - 20px * 1 / 2);
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            &::after {
                content: '';
                width: 100%;
                padding-top: 56.25%;
                background-color: rgba(16, 16, 16, 0.15);
                z-index: 1;
                pointer-events: none;
            }
            &:hover::after {
                background-color: rgba(16, 16, 16, 0.65);
            }

            a {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }
        }

        .category-image {
            position: absolute;
            object-fit: cover;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;
        }

        .category-label-wrapper {
            z-index: 2;
            position: absolute;
            bottom: 15px;
            left: 0;
            bottom: 20px;
            padding: 10px 20px 10px 20px;
            background-color: rgba(16, 16, 16, 0.65);
            color: #fafafa;

            .category-label {
                font-size: 18px;
            }
            .category-article-count {
                font-size: 14px;
                margin-top: 2px;
            }
        }
        li:hover {
            .category-label-wrapper {
                background-color: transparent;
                color: #33ccff;
            }
        }

        .loading-msg {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100px;
            width: 100%;
            font-style: italic;
        }
    }

    .term-panel {
        width: calc(50% - 10px);
        margin-right: 20px;

        .panel-body {
            padding: 40px 20px;
        }

        h2 {
            margin: 0 0 40px 0;
        }

        ol {
            list-style-type: none;
            margin: 0 0 -20px 0;
            padding: 0;
        }

        li {
            margin-bottom: 10px;
            font-size: 16px;
            background-color: #363636;
            color: #f0f0f0;
            &:hover {
                color: #33ccff;
            }

            a {
                display: block;
                padding: 15px 20px;
                color: inherit;
                text-decoration: none;
                position: relative;
            }
        }

        i {
            display: flex;
            height: 100%;
            align-items: center;
            position: absolute;
            top: 0;
            right: 20px;
            font-size: 18px;
        }
    }

    .new-article-panel {
        .panel-body {
            padding: 40px 20px;
        }

        h2 {
            margin: 0 0 40px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// KbHome.vue?71ba596e